module.exports = __webpack_public_path__ + "static/img/produto_g.d9f72cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_laranja/produto_g.png
// module id = XYnY
// module chunks = 0